/**
 * 测试环境 host
 */
const TEST_HOST = '__TEST_HOST__';

/**
 * url 中的 host
 */
const URL_HOST = (typeof location !== 'undefined' && location.host) || '';

/**
 * 是否为线下环境
 */
const isOffline = __OFF_LINE__ || URL_HOST.includes('.now.baidu.com')
|| URL_HOST.includes('.newapp.appspace.baidu.com');

/**
 * 封禁词提示文案
 */
const TIP_NEED_CHANGE_TOPIC = '换个话题聊聊吧，点击开始';
/**
 * 下载页面地址
 */
const DOWNLOAD_URL = 'https://yiyanapp.baidu.com/talk/download';
/**
 * UFO反馈地址
 */
const UFO_API = 'https://ufosdk.baidu.com/?m=Api&a=';

/**
 * 多选气泡的最大数量限制
 */
const MULTI_CHOOSE_COUNT_LIMIT = 40;

/**
 * 多选气泡的最大数量限制toast
 */
const MULTI_CHOOSE_COUNT_LIMIT_TOAST = '已超过最多可选数量';

/**
 * 多选气泡内容最大长度限制
 */
const MULTI_CHOOSE_CONTENT_LENGTH_LIMIT = 500;

/**
 * 单个会话最大消息条数
 */
const MESSAGE_COUNT_LIMIT = 500;

/**
 * 单个会话即将超限时的消息条数
 */
const MESSAGE_COUNT_WARNING = 496;

/**
 * 重新回答最大次数
 */
const REASK_COUNT_LIMIT = 5;

/**
 * 判定chunk延迟时间阈值
 */
const CHUNK_DELAY_TIME = 500;
/**
 * 回答停止提示
 */
const TIP_ANSWER_STOPED = '已停止回答';

/**
 * 回答异常提示
 */
const TIP_ANSWER_ABNORMAL = '人工智能可以提供便捷、安全、高效的服务。与我互动的人过多，请您稍后重新向我提问。';

/**
 * 消息封禁，替换答案
 */
const TIP_ANSWER_BAN = '人工智能的发展需要安全的网络环境，离不开你我的共同建设，当前与我互动的人过多，请稍候再试。';

/**
 * 会话限流错误文案
 */
const TIP_CHAT_LIMIT = '当前提问人数过多，先去社区看看，稍后再来吧';

/**
 * isSafe = 2 toast文案
 */
const SAFE2_TOAST = '根据网络监督管理要求，我无法回答这个问题，换个话题吧';

/**
 * 语聊页报错文案
 */
const TIP_VOICE_ASSISTANT_OFFLINE = '发生了点意外，点击重试';

/**
 * 正在回答中提示文案
 */
const TIP_ISANSWERING = '正在回答，请稍后再试';

const UPDATE_TOAST = 'APP版本过低，请升级后使用';

// 分享禁用 提示文案
const SHARE_DISABLE_TOAST = '正在审核中，通过后即可分享';

// 内容无意义 提示文案
const TIP_ANSWER_EMPTY = '当前主题无效，无法生成大纲';

// 内容违规 提示文案
const TIP_ANSWER_VIOLATION = '内容违规';

// 大纲格式错误 提示文案
const TIP_OUTLINE_FORMAT_ERROR = '大纲格式不规范，请修改后重试';

/**
 * 存储key前缀
 */
const STORAGE_KEY_PRE = 'WAN_HUA_IM_';

/**
 * Emoji插件id
 */
const EMOJI_PLUGIN_ID = 13;

/**
 * 分享面板的item btn
 */
enum SHARE_PANEL_ITEM {
    /** 微信好友 */
    WECHAT_FRIEND = 'wechat_friend',
    /** 微信朋友圈 */
    WECHAT_MOMENT = 'wechat_moment',
    /** 保存相册 (该能力 暂时不支持) */
    SAVE_IMAGE = 'save_image',
    /** 分享到社区 */
    SHARE_DISCOVER = 'share_discover',
    /** 复制链接 */
    COPY_LINK = 'copy_link',
    /** 生成长图 */
    LONG_IMAGE = 'long_image',
}

const DEFAULT_USER_AVATAR = 'https://b.bdstatic.com/searchbox/image/gcp/20230714/105421502.png';
// 最大token长度
const MAX_TOKEN_LENGTH = 4000;
// vip最大token长度
const VIP_MAX_TOKEN_LENGTH = 8000;

// 用户在eb3.5时，提示可切换到eb4.0的tip出现次数
const SHOW_CHANGETO_EB40_TIP = 1;
const SHOW_TOAST_LIMIT = 1;

enum MODELMAP {
    professional = 'eb40',
    basic = 'eb35',
    turbo = 'turbo40',
    x1 = 'ebx1',
    turboX1 = 'ebx1_turbo',
    eb45 = 'eb45',
    turbo45 = 'turbo45',
};
type ModelType = typeof MODELMAP[keyof typeof MODELMAP];

// 进入多选状态的来源，如分享、生成视频等
enum MULTIPLE_SELECT_SOURCE_MAP {
    SHARE = 'share',
    CREATE_VIDEO = 'create_video',
    DELETE = 'delete',
}
// 存储到本地的key
enum STORAGE_KEY {
    tipCount = 'SHOW_CHANGE_MODEL_TIP',
    toastMain = 'SHOW_REMIND_TOAST_MAIN',
};

// topbar的标题map
const TOPBAR_TITLE_MAP = {
    [MULTIPLE_SELECT_SOURCE_MAP.SHARE]: '选择分享内容',
    [MULTIPLE_SELECT_SOURCE_MAP.CREATE_VIDEO]: '选择对话生成视频',
    [MULTIPLE_SELECT_SOURCE_MAP.DELETE]: '选择对话',
};

enum PAGE_TYPE {
    MAIN = 'main_chat',
    SECOND = 'second_chat',
    UNKNOWN = 'unknown',
    MULTI_MODE = 'multi_mode_chat',
    QUESTION = 'multi_mode_question_chat',
    VIDEO = 'video_chat',
    COMMENT = 'comment_chat',
    EXPLORE_WORLD = 'multi_mode_explore_world_chat',
    AI_PPT = 'ai_ppt',
}

// 页面来源，端通通过历史或者欢迎语通道传进来
enum PAGE_FROM {
    // 本地搜索打开二级页
    SEARCH = 'search',
    // 照相馆场景push消息打开二级页
    PUSH = 'push',
    // 社区半屏页的继续问按钮跳转打开二级页
    COMMENT = 'comment',
    // 主会话语聊气泡卡片打开二级页
    PHONE_CALL = 'phoneCall',
    // pc客户端
    NEWAPP_PC_CLIENT = 'newapp_pc_client',
}

// 页面标识到打点page枚举映射
const PAGE_TYPE_LOG: Record<PAGE_TYPE, string> = {
    [PAGE_TYPE.MAIN]: 'homepage',
    [PAGE_TYPE.SECOND]: 'talk',
    [PAGE_TYPE.UNKNOWN]: '',
    [PAGE_TYPE.MULTI_MODE]: 'vqa_assistant',
    [PAGE_TYPE.QUESTION]: 'question_assistant',
    [PAGE_TYPE.VIDEO]: 'video_chat',
    [PAGE_TYPE.COMMENT]: 'comment_chat',
    [PAGE_TYPE.EXPLORE_WORLD]: 'TAgent',
    [PAGE_TYPE.AI_PPT]: 'outline',
};

// 春节活动日期
enum ACTIVITY_DATE {
    START_DATE = '2024-02-05T00:00:00',
    END_DATE = '2024-02-24T23:59:59',
}

// 任务id
enum ACTIVITY_ID {
    ASK = '1125',
    VIRTUAL_HUMAN= '1124',
}

enum ACTIVITY_TIP {
    tipIdStorage = 'TIP_ACTIVITY_ID',
    tipCountStorage = 'CLOSE_ACTIVITY_TIP_COUNT',
    tipTmpStorage = 'CLOSE_ACTIVITY_TIP_TMP',
    maxCloseCount = 2,
}

// ugc引导类型
enum UGC_GUIDE_TYPE {
    // (好运中国年)导量任务
    CNY = 'cny',
    NEW_USER_BOOT = 'newUserBoot',
    UPGRADE_USER_BOOT ='upgradeUserBoot'
}

enum GLOBE_MESSAGE_TYPE {
    // 关闭全屏语音 = 'closeFullScreenVoice',
    CLOSE_FULL_SCREEN_VOICE_CHAT = 'closeFullScreenVoiceChat',
}

/**
 * 端能力切换主对话的tab实现有问题，发现tab的参数为prompt，社区tab的参数为discovery
 * 这里调换一下两者的参数
 */
enum SEEK_TAB_PARAMS {
    PROMPT = 'discovery',
    DISCOVERY = 'prompt'
}

enum LITE_CHAT_POS_MAP {
    LITECHAT_CHARACTER_TALK = 'litechat_character_talk',
    LITECHAT_PROMPT_TALK = 'litechat_prompt_talk',
    INVOKE_HOME = 'invoke_home',
    LITECHAT_CHARACTER_CALL = 'litechat_character_call',
    LITECHAT_SUG_CARD1 = 'litechat_sug_card1',
    LITECHAT_SUG_CARD2 = 'litechat_sug_card2',
    LITECHAT_SUG_CARD3 = 'litechat_sug_card3',
    NEWYEAR_CARD_INVOKE = 'newyear_card_invoke',
}

// 二级页展示干预卡枚举，枚举值来自配置的干预卡type
enum SECOND_CARD_CONFIG {
    SUGACTIVITY = 'poemcard',
}

// loading前边的文案
const LOADING_TEXT: Record<string, string> =  {
    search: '正在搜索全网内容',
    hcg: '正在解读中',
    imgSearch: '正在搜索全网内容',
    inferenceSearch: '正在搜索中',
    // 'LLM.chat': '正在深入分析',
};

/**
 * 历史会话拉取方向
 * 0=>(手指下滑)数据向上拉，拉取旧的信息
 * 1=>(手指上滑)数据向下拉，拉取新的信息
 */
enum PULL_LOAD_DIRECTION {
    DOWN = 'down',
    UP = 'up'
}

/**
 *  图片类型
 */
const enum IMG_CLASS {
    /**
     * 长按可呼出操作菜单
     */
    LONG_PRESS_ABLE_IMG = 'long-press-able-img',
    /**
     * 图片触发风控，禁止图片问答和ai修图
     */
    IMAGE_BAN = 'image-ban',
}
enum SUG_CANCEL_TYPE {
    NEW_QUESTION = 'new_question', // 发起新问题
    STOP_ANSWER = 'stop_answer', // 停止回答且 finish 为 1
    STOP_ANSWER_UNFINISH = 'stop_answer_unfinish', // 停止回答且 finish 为 0
    RE_SESSION = 're_session', // 重置 session
    RE_ANSWER = 're_answer', // 重新回答
    NEED_RETRY = 'need_retry', // 接口返回
    MSG_ID = 'msg_id', // 接口返回
    MAX_WAIT_TIME = 'max_wait_time', // 接口返回
}

const enum MODEL_TAG_NAME {
    EB35 = '文心 3.5',
    EB40 = '文心 4.0',
    TURBO40 = '文心 4.0 Turbo',
    HCG = '百度健康',
    DEEPSEEK = 'DeepSeek',
    X1 = '文心 X1',
    EB45 = '文心 4.5',
}
enum END_POINT {
    HCG = 'hcg',
    HCG_DEFAULT = 'hcgDefault',
    ANNUAL_REVIEW ='annualReview',
}

// 多模对话页固定文案
const PROLOGUE_TEXT: Record<string, string> =  {
    multi: '关于这张图片，你有什么想问的？',
    video: '有什么问题都可以问我哦～',
    world: '选个人格，解锁专属冷知识盲盒',
};

const MESSAGE_STATUS: Record<string, string> =  {
    processing: 'processing',
    finished: 'finished',
    stopped: 'stopped',
};
enum PayCardType {
    SINGLE = 'single',
    MONTHPAY = 'monthPay',
    YEARPAY = 'yearPay',
}

interface LogIdMap {
    [key: string]: string;
}

const LOG_ID_MAP: LogIdMap =  {
    '6412': '7566',
    '6413': '7575',
    '6414': '7576',
    '6415': '7577',
};

const PAY_CARD_NA_MAP = {
    [PayCardType.SINGLE]: 1,
    [PayCardType.MONTHPAY]: 3,
    [PayCardType.YEARPAY]: 4,
};

const PAY_CARD_MAP = {
    [PayCardType.SINGLE]: '特惠日卡',
    [PayCardType.MONTHPAY]: '畅享月卡',
    [PayCardType.YEARPAY]: '尊享年卡',
    '1': '特惠日卡',
    '3': '畅享月卡',
    '4': '尊享年卡',
};

const FORBIDE_EDIT_TEXT = '请前往文心智能体平台编辑查看';
// 多模相关storage
const MULTI_STORAGE = {
    ask: 'SEND_MULTI_ASK',
    guide: 'JUMP_MULTI_PAGE',
};

const HISTORY_STORAGE = {
    video: 'SEND_VIDEO_ASK',
    digital: 'SEND_DIGITAL_ASK',
};

// 展示滚动到底部的临界值，行高
const SHOW_BACKBOTTOM_HEIGHT = 80;

// 推荐横滑卡的数据埋点上报rec_content_type的值、传递给客户端的pageType
const RECOMMEND_TYPE_MAP: {[key: string]: 'text' | 'pic' | 'video' | 'feedpictext' | 'feedpic'} = {
    '4': 'text', // 纯文本
    '5': 'pic', // 图文
    '6': 'video', // 搜索视频
    '7': 'feedpictext', // feed图文
    '8': 'video', // feed小视频
    '9': 'feedpic', // feed动态
};

// 会话消息类型 v4.5版本新增
enum BOT_SOURCE_TYPE {
    // 普通bot类型
    SESSION = 1,
    // prompt bot 类型
    PROMPT = 2,
    // 伙伴类型
    CHARACTER = 3,
    // 智能体类型
    AGENT = 4,
    // 话题类型, pc bot
    TOPIC = 5,
    // 灵境智能体
    LINGJING = 10,
}

const studyCharacterIdList = [
    '1139569', // 非正式
    '1098018', // 正式
    '278019', // 线下
];

// 春节贺卡智能体
const greetCardCharacterIdList = [
    '280125', // 线下-福气春联
    '280145', // 线下-新年上上签
    '280146', // 线下-新年答案
    '1591321', // 线上-福气春联
    '1592169', // 线上-新年上上签
    '1592212', // 线上-新年答案
];
const UPLOAD_FILE_ANIMATION = 'UPLOAD_FILE_ANIMATION';

// 缩略图处理参数
const THUMB_PROCESS_PARAMS = '/resize,m_lfit,w_12';

// 新用户过期时间标记
const NEW_USER_TIMES_KEY = 'NEW_USER_TIMESTAMP';

// sug推荐卡片类型
enum SUG_CARD_CONFIG {
    // 法律卡
    LAWSUG = 'character_law',
};

// 多选类型
enum CHECK_TYPE_MAP {
    SHARE = 'share',
    DELETE= 'delete',
}

// 底部弹窗类型
enum FOOTER_TIP_TYPE {
    SINGLE = 'single',
    DOUBLE = 'double',
    WARNING = 'warning',
}

enum DEFERRED_SCENE {
    IMG_TEXT_SEARCH = 'imgTextSearch',
    REFERENCE_TAG = 'referenceTag',
}

// 伙伴统一开关状态
const UNIFICATION_SWITCH_STATUS = 'UNIFICATION_SWITCH_STATUS';

enum SESSION_INIT_TYPE {
    NORMAL = 'normal',
    MODEL_CHANGE = 'modelChange',
    CLEAR_CONTEXT = 'clearContext',
    RISK_CONTROL = 'riskControl',
    HISTORY = 'history',
}

// 该上下文是否需要被记忆
enum NEED_MEMORIZE_CONTEXT {
    YES = 1,
    NO = 0,
}

// 设备尺寸
enum DEVICE_SIZE {
    SMALL = 'small',
    MEDIUM = 'medium',
    LARGE = 'large',
}

// appmode 模式
const APP_MODE: {[key: string]: string} = {
    'DeepSeek-R1': 'deepseek',
    'auto': 'auto',
    'eb': 'eb',
};

// weboffice来源标记
export const enum WebOfficeSource {
    DEEP_SEARCH = 'deep_search',
    BUB = 'bub',
    BUB_EXPORT = 'bub_export',
    AI_PPT = 'ai_ppt'
}

// 活动ID
export const enum ActivityId {
    AI_PPT = 'aiPPT',
    Comics = 'comic',
};

export {
    ACTIVITY_DATE,
    ACTIVITY_ID,
    ACTIVITY_TIP,
    APP_MODE,
    BOT_SOURCE_TYPE,
    CHECK_TYPE_MAP,
    CHUNK_DELAY_TIME,
    DEFAULT_USER_AVATAR,
    DEFERRED_SCENE,
    DEVICE_SIZE,
    DOWNLOAD_URL,
    EMOJI_PLUGIN_ID,
    END_POINT,
    FOOTER_TIP_TYPE,
    FORBIDE_EDIT_TEXT,
    GLOBE_MESSAGE_TYPE,
    greetCardCharacterIdList,
    HISTORY_STORAGE,
    IMG_CLASS,
    isOffline,
    LITE_CHAT_POS_MAP,
    LOADING_TEXT,
    LOG_ID_MAP,
    MAX_TOKEN_LENGTH,
    // 其他常量
    MESSAGE_COUNT_LIMIT,
    MESSAGE_COUNT_WARNING,
    MESSAGE_STATUS,
    MODEL_TAG_NAME,
    MODELMAP,
    ModelType,
    MULTI_CHOOSE_CONTENT_LENGTH_LIMIT,
    MULTI_CHOOSE_COUNT_LIMIT,
    MULTI_CHOOSE_COUNT_LIMIT_TOAST,
    MULTI_STORAGE,
    MULTIPLE_SELECT_SOURCE_MAP,
    NEED_MEMORIZE_CONTEXT,
    NEW_USER_TIMES_KEY,
    PAGE_FROM,
    PAGE_TYPE,
    PAGE_TYPE_LOG,
    PAY_CARD_MAP,
    PAY_CARD_NA_MAP,
    PayCardType,
    PROLOGUE_TEXT,
    PULL_LOAD_DIRECTION,
    REASK_COUNT_LIMIT,
    RECOMMEND_TYPE_MAP,
    SAFE2_TOAST,
    SECOND_CARD_CONFIG,
    SEEK_TAB_PARAMS,
    SESSION_INIT_TYPE,
    SHARE_DISABLE_TOAST,
    SHARE_PANEL_ITEM,
    SHOW_BACKBOTTOM_HEIGHT,
    SHOW_CHANGETO_EB40_TIP,
    SHOW_TOAST_LIMIT,
    // ERROR_错误原因
    STORAGE_KEY,
    STORAGE_KEY_PRE,
    studyCharacterIdList,
    SUG_CANCEL_TYPE,
    SUG_CARD_CONFIG,
    TEST_HOST,
    THUMB_PROCESS_PARAMS,
    TIP_ANSWER_ABNORMAL,
    TIP_ANSWER_BAN,
    TIP_ANSWER_EMPTY,
    TIP_ANSWER_STOPED,
    TIP_ANSWER_VIOLATION,
    TIP_CHAT_LIMIT,
    TIP_ISANSWERING,
    TIP_NEED_CHANGE_TOPIC,
    TIP_OUTLINE_FORMAT_ERROR,
    TIP_VOICE_ASSISTANT_OFFLINE,
    TOPBAR_TITLE_MAP,
    UFO_API,
    UGC_GUIDE_TYPE,
    UNIFICATION_SWITCH_STATUS,
    UPDATE_TOAST,
    UPLOAD_FILE_ANIMATION,
    VIP_MAX_TOKEN_LENGTH,
};
